const PORTFOLIO_CATEGORY = 'portfolio'

export const PORTFOLIO_EVENTS = {
  PORTFOLIO_REFRESH_CLICKED: {
    action: 'Portfolio refresh clicked',
    category: PORTFOLIO_CATEGORY,
  },
}
